var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5237_7429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 5.71276C1.33301 4.9153 1.6546 4.42659 2.32009 4.05623L5.05959 2.53167C6.49507 1.73281 7.21282 1.33337 7.99967 1.33337C8.78653 1.33337 9.50427 1.73281 10.9398 2.53167L13.6793 4.05623C14.3448 4.42659 14.6663 4.9153 14.6663 5.71276C14.6663 5.929 14.6663 6.03712 14.6427 6.126C14.5187 6.593 14.0955 6.66671 13.6868 6.66671H2.31253C1.90385 6.66671 1.48069 6.593 1.35662 6.126C1.33301 6.03712 1.33301 5.929 1.33301 5.71276Z",
    stroke: "#3D3D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 6.66675V12.3334M5.33268 6.66675V12.3334",
    stroke: "#3D3D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 12.3334H3.33301C2.22844 12.3334 1.33301 13.2288 1.33301 14.3334C1.33301 14.5175 1.48225 14.6667 1.66634 14.6667H7.33301",
    stroke: "#3D3D43",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.333 9.66671L9.66634 14.3334",
    stroke: "#3D3D43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.166,
    cy: 10.1667,
    r: 0.5,
    stroke: "#3D3D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.833,
    cy: 13.8334,
    r: 0.5,
    stroke: "#3D3D43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5237_7429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTax);
export default __webpack_public_path__ + "static/media/icon-tax.9d42966bd739eb776e7633a53aef0167.svg";
export { ForwardRef as ReactComponent };